import { Route, Switch } from "react-router-dom";

import { DashboardBranchList as List } from "./list";

const DashboardBranch = () => {

  return (
    <Switch>
      <Route component={List} />
    </Switch>
  );
};

export default DashboardBranch;
